import React from 'react';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    Paper, Typography, CircularProgress, IconButton, Tooltip
} from '@material-ui/core';
import HistoryIcon from '@material-ui/icons/History';
import RefreshIcon from '@material-ui/icons/Refresh';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import { ContractStatusBadge } from '../status-badge';
import SectionCard from '../section-card';

/**
 * Tabela profissional do histórico de status do contrato.
 * Reusada nas abas "Histórico de Status" de admin-trial-detail e admin-subscription-detail.
 *
 * Props:
 *  - items, loading, onRefresh
 */
function StatusHistoryTable({ items, loading, onRefresh }) {
    const list = items || [];

    const actions = onRefresh ? (
        <Tooltip title="Atualizar">
            <IconButton size="small" onClick={onRefresh} disabled={loading}>
                <RefreshIcon />
            </IconButton>
        </Tooltip>
    ) : null;

    return (
        <SectionCard context="history" title="Histórico de Status" actions={actions} noPadding>
            {loading && (
                <div style={{ textAlign: 'center', padding: 32 }}>
                    <CircularProgress size={28} />
                </div>
            )}

            {!loading && list.length === 0 && (
                <div style={{ margin: 16, textAlign: 'center', padding: 48, border: '1px dashed #e0e0e0', borderRadius: 8, backgroundColor: '#fafafa' }}>
                    <HistoryIcon style={{ fontSize: 56, color: '#bdbdbd' }} />
                    <Typography variant="body1" style={{ color: '#757575', marginTop: 8, fontWeight: 500 }}>
                        Nenhuma mudança de status registrada
                    </Typography>
                    <Typography variant="body2" style={{ color: '#9e9e9e', marginTop: 4 }}>
                        As transições futuras (bloquear/desbloquear/cancelar/reativar/expirar) aparecerão aqui.
                    </Typography>
                </div>
            )}

            {!loading && list.length > 0 && (
                <TableContainer component={Paper} variant="outlined" style={{ borderRadius: 0, borderLeft: 0, borderRight: 0, borderBottom: 0 }}>
                    <Table size="small">
                        <TableHead>
                            <TableRow style={{ backgroundColor: '#fafafa' }}>
                                <TableCell style={{ fontWeight: 600, width: 180 }}>Data / Hora</TableCell>
                                <TableCell style={{ fontWeight: 600 }}>Transição</TableCell>
                                <TableCell style={{ fontWeight: 600 }}>Mensagem</TableCell>
                                <TableCell style={{ fontWeight: 600, width: 200 }}>Por</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {list.map((row, idx) => {
                                const date = row.occurrencedate || row.createdat;
                                const dateStr = date ? new Date(date).toLocaleString('pt-BR') : '-';
                                const isSystem = !row.createduser;
                                const userLabel = isSystem
                                    ? 'Sistema (automático)'
                                    : (row.createdusername || `Usuário #${row.createduser}`);
                                return (
                                    <TableRow key={row.id || idx} hover>
                                        <TableCell style={{ fontFamily: 'monospace', fontSize: 12, color: '#424242' }}>
                                            {dateStr}
                                        </TableCell>
                                        <TableCell>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                                {row.previouscontractstatusid != null ? (
                                                    <ContractStatusBadge statusId={row.previouscontractstatusid} />
                                                ) : (
                                                    <span style={{ color: '#9e9e9e', fontSize: 12, fontStyle: 'italic' }}>
                                                        (inicial)
                                                    </span>
                                                )}
                                                <ArrowRightAltIcon style={{ color: '#757575' }} />
                                                <ContractStatusBadge statusId={row.contractstatusid} />
                                            </div>
                                        </TableCell>
                                        <TableCell style={{ color: '#424242', fontSize: 13 }}>
                                            {row.message || '-'}
                                        </TableCell>
                                        <TableCell>
                                            {isSystem ? (
                                                <span style={{
                                                    display: 'inline-block',
                                                    padding: '2px 8px',
                                                    borderRadius: 4,
                                                    backgroundColor: '#e3f2fd',
                                                    color: '#1565c0',
                                                    fontSize: 11,
                                                    fontWeight: 600,
                                                }}>
                                                    ⚙ Sistema
                                                </span>
                                            ) : (
                                                <span style={{ fontSize: 13, color: '#424242' }}>
                                                    {userLabel}
                                                </span>
                                            )}
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </SectionCard>
    );
}

export default StatusHistoryTable;
